import img from '../../assets/keith-ryan.jpg';

const Keith = {
  name: 'Keith Ryan',
  bio: 'Keith Ryan is a product manager for the Product Team. He is also an avid rock climber with a specific passion for bouldering.',
  url: 'keith',
  img,
};

export default Keith;
